import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nav-item" }
const _hoisted_2 = ["aria-current"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updatePage && _ctx.updatePage(...args)), ["prevent"])),
      class: _normalizeClass(["nav-link", {active: _ctx.active}]),
      "aria-current": _ctx.active ? 'page' : undefined,
      href: "#"
    }, _toDisplayString(_ctx.operation), 11, _hoisted_2)
  ]))
}